import { render, staticRenderFns } from "./particular.vue?vue&type=template&id=18c219d2&scoped=true&"
import script from "./particular.vue?vue&type=script&lang=js&"
export * from "./particular.vue?vue&type=script&lang=js&"
import style0 from "./particular.vue?vue&type=style&index=0&id=18c219d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c219d2",
  null
  
)

export default component.exports